import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SessionExpiredGuard } from './core/auth/guards/session-expired.guard';
import { DashboardComponent } from './dashboard/dashboard.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [SessionExpiredGuard],
    canActivateChild: [SessionExpiredGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: DashboardComponent,
        data: { title: 'Dashboard' }
      },
      { path: 'dashboard', redirectTo: '' },
      {
        path: 'account',
        loadChildren: () => import('src/app/account/account.module').then(m => m.AccountModule)
      },
      {
        path: 'admin',
        loadChildren: () => import('src/app/admin/admin.module').then(m => m.AdminModule)
      },
      {
        path: 'useradmin',
        loadChildren: () => import('src/app/useradmin/useradmin.module').then(m => m.UserAdminModule)
      },
      {
        path: 'agency',
        loadChildren: () => import('src/app/agency/agency.module').then(m => m.AgencyModule)
      },
      {
        path: 'claim',
        loadChildren: () => import('src/app/claim/claim.module').then(m => m.ClaimModule)
      },
      {
        path: 'policy',
        loadChildren: () => import('src/app/policy/policy.module').then(m => m.PolicyModule)
      },
      {
        path: 'profile',
        loadChildren: () => import('src/app/profile/profile.module').then(m => m.ProfileModule)
      },
      {
        path: 'resources',
        loadChildren: () => import('src/app/resource/resource.module').then(m => m.ResourceModule)
      },
      { path: 'search', loadChildren: () => import('src/app/search/search.module').then(m => m.SearchModule) },
      { path: 'contacts', loadChildren: () => import('src/app/contact/contact.module').then(m => m.ContactModule) }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(
    routes,
    {
    onSameUrlNavigation: 'reload',
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    relativeLinkResolution: 'legacy'
}
  )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
